module.exports = __webpack_public_path__ + "static/media/IMG_5995.7aab0e95.jpg";